import React, { useContext, useMemo } from "react";
import { InventoriesProductoLogContext } from "../../../../../js/app/context/InventoriesProductoLog";
import DateTable from "../../../../controls/DateTable";
import { formatDate } from "../../../../../js/helpers/formatDates";
import { getUniqueFilters } from "../../../../../js/helpers/getUniqueFilters";
import { Tag } from "antd";

const InventoriesLogList = () => {
  const { logProductos, loading } = useContext(InventoriesProductoLogContext);

  const transformedData = logProductos.map((item) => ({
    ...item,
    producto:
      item.inventarioProductoDTO?.productoSucursalDTO?.descripcion || "N/A",
    empresa: item.inventarioProductoDTO?.productoSucursalDTO?.empresa || "N/A",
    sucursal:
      item.inventarioProductoDTO?.productoSucursalDTO?.sucursal || "N/A",
    usuario: item.usuarioDTO?.nombre || item.usuarioDTO?.nick || "N/A",
    fecha: formatDate(item.fecha),
  }));

  const getAccionTag = (accion) => {
    const color =
      accion === "Sumar" ? "green" : accion === "Actualizar conteo" ? "gold" : "blue";
    return <Tag color={color}>{accion}</Tag>;
  };


  // Options para filtros de empresa, sucursal, usuarios, y acciones
  const empresaFilters = useMemo(
    () => getUniqueFilters(transformedData, "empresa"),
    [transformedData]
  );
  const sucursalFilters = useMemo(
    () => getUniqueFilters(transformedData, "sucursal"),
    [transformedData]
  );
  const usuarioFilters = useMemo(
    () => getUniqueFilters(transformedData, "usuario"),
    [transformedData]
  );
  const accionFilters = useMemo(
    () => getUniqueFilters(transformedData, "accion"),
    [transformedData]
  );

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      search: true,
    },
    {
      title: "Producto",
      dataIndex: "producto",
      key: "producto",
      search: true,
    },
    {
      title: "Empresa",
      dataIndex: "empresa",
      key: "empresa",
      filters: empresaFilters,
      onFilter: (value, record) => record.empresa === value,
    },
    {
      title: "Sucursal",
      dataIndex: "sucursal",
      key: "sucursal",
      filters: sucursalFilters,
      onFilter: (value, record) => record.sucursal === value,
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "fecha",
      render: (text) => formatDate(text),
      search: true,
    },
    {
      title: "Usuario",
      dataIndex: "usuario",
      key: "usuario",
      filters: usuarioFilters,
      onFilter: (value, record) => record.usuario === value,
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
      filters: accionFilters,
      onFilter: (value, record) => record.accion === value,
      render: (text) => getAccionTag(text)
    },
    {
      title: "Cantidad ingresada",
      dataIndex: "cantidadIgresada",
      key: "cantidadIgresada",
      search: true,
    },
  ];

  return (
    <>
      <DateTable data={transformedData} columns={columns} loading={loading} />
    </>
  );
};

export default InventoriesLogList;
